// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 453 ? "eef9e134" : chunkId) + "." + {"453":"7056bfe3f36d7932","564":"e9573ddc608b4304"}[chunkId] + ".js";
};